"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconGauge = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M43 29.11a1.44 1.44 0 0 0-1.5-.34c-1.64.59-9.9 3.6-11.72 5.42a5.75 5.75 0 0 0 0 8.13 5.75 5.75 0 0 0 8.13 0c1.82-1.82 4.84-10.08 5.42-11.72a1.44 1.44 0 0 0-.34-1.5zM35.93 40.3a2.88 2.88 0 0 1-4.07-4.07c.77-.77 4.36-2.34 7.71-3.65-1.31 3.35-2.88 6.95-3.65 7.71zm0 0"
  }), _react["default"].createElement("path", {
    d: "M35 9.12a28.74 28.74 0 0 0-23.54 12.26c-.95 1.42-1.54 2.43-1.54 2.43a28.74 28.74 0 0 0 2.54 32l1.9 2.16a29.22 29.22 0 0 0 3 2.66 1.44 1.44 0 0 0 .88.3h33.53a1.43 1.43 0 0 0 .88-.3A28.76 28.76 0 0 0 35 9.12zm19.29 46l-4-4a1.44 1.44 0 1 0-2 2l4 4q-.48.43-1 .84H36.44V53.7a1.44 1.44 0 0 0-2.88 0V58H18.73q-.51-.41-1-.84l4-4a1.44 1.44 0 0 0-2-2l-4 4-.07-.08a1.48 1.48 0 0 0-.18-.22 25.68 25.68 0 0 1-6.26-15.5h5.71a1.44 1.44 0 0 0 0-2.88H9.16a25.77 25.77 0 0 1 6.56-15.81l4 4a1.44 1.44 0 0 0 2-2l-4-4A25.77 25.77 0 0 1 33.56 12v5.71a1.44 1.44 0 0 0 2.88 0V12a25.77 25.77 0 0 1 15.81 6.6l-4 4a1.44 1.44 0 1 0 2 2l4-4a25.77 25.77 0 0 1 6.56 15.81h-5.68a1.44 1.44 0 0 0 0 2.88h5.71a25.66 25.66 0 0 1-6.55 15.85z"
  })),
  height: undefined,
  width: undefined
});
IconGauge.displayName = 'IconGauge';
var _default = IconGauge;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/gauge.js
// module id = 598
// module chunks = 0